var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"basic-button",class:_setup.classes,attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"basic-button__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }